import React from 'react'
import {
  SmartSubscriptionRoot,
  Header,
  Description,
  ListContainer,
  BenefitContainer,
  IconContainer,
} from './SmartSubscription.styles'
import { useTranslation } from 'hooks/useTranslation'
import { AlignedList } from 'components/AlignedList'
import { Text } from 'components/Text'
import Trans from 'next-translate/Trans'
import { TranslationKeys } from 'locales/translationKeys'
import { Button } from 'components/Button'
import Link from 'next/link'
import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import { SizeTokens } from 'stitches.config'

type SmartSubscriptionProps = {}

export const SmartSubscription: React.FC<SmartSubscriptionProps> = ({}) => {
  const { t } = useTranslation()

  type BenefitProps = {
    iconName: IconName
    text: TranslationKeys
    size: SizeTokens
  }

  const benefits: BenefitProps[] = [
    {
      iconName: 'dachshund',
      size: "13",
      text: 'raw-food-subscription:subscription.bullets.0',
    },
    {
      iconName: 'truck',
      size: "11",
      text: 'raw-food-subscription:subscription.bullets.1',
    },
    {
      iconName: 'box',
      size: "12",
      text: 'raw-food-subscription:subscription.bullets.2',
    },
    {
      iconName: 'bowl',
      size: "12",
      text: 'raw-food-subscription:subscription.bullets.3',
    },
    {
      iconName: 'protection',
      size: "10",
      text: 'raw-food-subscription:subscription.bullets.4',
    },
  ]

  const Benefit = ({ text, iconName, size }: BenefitProps) => (
    <BenefitContainer>
      <IconContainer>
        <Icon name={iconName} size={size} color="primary-500" />
      </IconContainer>
      <Text>
        <Trans
          i18nKey={text}
          components={{
            bold: <Text weight="bold" css={{display: 'inline'}}/>,
          }}
        />
      </Text>
    </BenefitContainer>
  )

  const BenefitElementList = benefits.map(({ text, iconName, size }, index) => (
    <Benefit size={size} key={index} iconName={iconName} text={text} />
  ))

  return (
    <SmartSubscriptionRoot>
      <Header>{t('raw-food-subscription:subscription.title')}</Header>
      <Description>{t('raw-food-subscription:subscription.description')}</Description>
      <ListContainer>
        <AlignedList listElements={BenefitElementList} />
      </ListContainer>
      <Link href="/meal-plan" passHref>
        <Button className='cta'>{t('raw-food-subscription:cta')}</Button>
      </Link>
    </SmartSubscriptionRoot>
  )
}
